import { render, staticRenderFns } from "./RecordButton.vue?vue&type=template&id=201b786a&scoped=true&"
import script from "./RecordButton.vue?vue&type=script&lang=js&"
export * from "./RecordButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201b786a",
  null
  
)

export default component.exports